import { GenericCartProvider } from '@contexts/GenericCartContext/GenericCartContext';
import { CauserieProvider } from '@contexts/CauserieContext/CauserieContext';
import { FormationProvider } from '@contexts/FormationContext/FormationContext';
import { ErrorProvider } from '@contexts/ErrorContext';
import { HomeSecurityProvider } from '@contexts/HomeSecurityContext/HomeSecurityContext';
import { PageTitleProvider } from '@contexts/PageTitleContext';
import { Button, Modal, Typography } from '@design-system';
import { getIsLogged, getSignature } from '@features/auth/auth.slice';
import { useAutoDisconnect, useNativeBack, useNativeFCMToken, useViewportHeight } from '@hooks';
import React from 'react';
import { useSelector } from 'react-redux';
import { useRoutes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { routes } from '../routes/routes';
import './App.scss';
import { InitialiseThirdParties } from './InitialiseThirdParties';
import { useAppVM } from './useAppVM';
import { useNotificationRedirect } from './useNotificationRedirect';
import { useSyncFcmToken } from './useSyncFcmToken';

const App: React.FC = () => {
    const isLogged = useSelector(getIsLogged);
    const signature = useSelector(getSignature);
    const routing = useRoutes(routes(!!isLogged, signature));

    useNativeFCMToken();
    useSyncFcmToken();
    useNotificationRedirect();
    useViewportHeight();
    useAppVM();
    useAutoDisconnect();

    const { displayExitConfirmationPopup, setDisplayExitConfirmationPopup, handleAppExit } = useNativeBack();

    return (
        <div className="app">
            <InitialiseThirdParties />
            <ErrorProvider>
                <PageTitleProvider>
                    <CauserieProvider>
                        <FormationProvider>
                            <HomeSecurityProvider>
                                <GenericCartProvider>
                                    {routing}
                                    <ToastContainer limit={1} />
                                    {displayExitConfirmationPopup && (
                                        <Modal
                                            open={displayExitConfirmationPopup}
                                            setClose={() => setDisplayExitConfirmationPopup(false)}
                                            title="Voulez-vous quitter l'application ?"
                                        >
                                            <Button
                                                color="grey"
                                                variant="primary"
                                                size="fullwidth"
                                                onClick={handleAppExit}
                                                className="mb-medium-spacing mt-x-large-spacing"
                                            >
                                                <Typography intrinsic="h4">Quitter l'application</Typography>
                                            </Button>
                                            <Button
                                                color="green"
                                                variant="secondary"
                                                size="fullwidth"
                                                onClick={() => setDisplayExitConfirmationPopup(false)}
                                            >
                                                <Typography intrinsic="h4">Rester dans l'application</Typography>
                                            </Button>
                                        </Modal>
                                    )}
                                </GenericCartProvider>
                            </HomeSecurityProvider>
                        </FormationProvider>
                    </CauserieProvider>
                </PageTitleProvider>
            </ErrorProvider>
        </div>
    );
};

export default App;
